export const noise = /* glsl */`
float hash(vec3 p){p=fract(p*.3183099+.1);p*=17.;return fract(p.x*p.y*p.z*(p.x+p.y+p.z));}
float noise3(vec3 p){vec3 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(mix(hash(i),hash(i+vec3(1,0,0)),f.x),mix(hash(i+vec3(0,1,0)),hash(i+vec3(1,1,0)),f.x),f.y),mix(mix(hash(i+vec3(0,0,1)),hash(i+vec3(1,0,1)),f.x),mix(hash(i+vec3(0,1,1)),hash(i+vec3(1,1,1)),f.x),f.y),f.z);}
float fbm(vec3 p){float f=0.,a=.5;for(int i=0;i<5;i++){f+=a*noise3(p);p=p*2.03+vec3(5.2,1.3,8.7);a*=.5;}return f;}
`;
export const planetVertex = /* glsl */`
varying vec3 vP;varying vec3 vN;varying vec3 vWorld;
void main(){vP=position;vN=normalize(mat3(modelMatrix)*normal);vec4 p=modelMatrix*vec4(position,1.);vWorld=p.xyz;gl_Position=projectionMatrix*viewMatrix*p;}
`;
export const planetFragment = /* glsl */`
uniform float uType;uniform float uTime;varying vec3 vP;varying vec3 vN;varying vec3 vWorld;
${noise}
void main(){
vec3 p=normalize(vP),n=normalize(vN),V=normalize(cameraPosition-vWorld),L=normalize(vec3(-.8,.45,.7));
float sun=dot(n,L),day=smoothstep(-.12,.28,sun),rim=pow(1.-max(dot(n,V),0.),3.5);
vec3 color=vec3(.5);float emission=0.;float water=0.;
if(uType<.5 || uType>5.5){
  float flow=fbm(vec3(p.x*4.,p.y*12.,p.z*4.));
  float bands=sin(p.y*65.+flow*9.+noise3(p*19.)*1.2)*.5+.5;
  float fine=sin(p.y*240.+flow*25.)*.5+.5;
  color=mix(vec3(.32,.23,.19),vec3(.79,.66,.48),smoothstep(.1,.9,bands));
  color=mix(color,vec3(.91,.81,.63),smoothstep(.58,.72,flow)*.75);
  color*=.89+fine*.18;
  if(uType>5.5) color=mix(vec3(.045,.12,.19),vec3(.32,.65,.72),smoothstep(.12,.86,bands))*(.8+flow*.5);
  float storm=length((p.xy-vec2(.28,-.22))*vec2(1.5,3.5));
  color=mix(color,vec3(.54,.34,.23),smoothstep(.27,.08,storm)*.55);
}else if(uType<1.5){
  float continent=fbm(p*3.2+vec3(4.));float detail=fbm(p*24.);
  water=1.-smoothstep(.49,.53,continent);
  vec3 sea=mix(vec3(.009,.045,.11),vec3(.025,.28,.37),smoothstep(.36,.52,continent));
  vec3 land=mix(vec3(.08,.17,.12),vec3(.38,.37,.23),detail);
  color=mix(land,sea,water);
  float pole=smoothstep(.72,.94,abs(p.y)+detail*.12);color=mix(color,vec3(.8,.86,.88),pole);
  vec3 cp=p*6.+vec3(uTime*.003,0.,0.);float cloud=fbm(cp+fbm(p*8.)*.7);
  color=mix(color,vec3(.83,.88,.91),smoothstep(.52,.68,cloud)*.93);
  color+=vec3(.8,.91,1.)*pow(max(dot(reflect(-L,n),V),0.),100.)*water*.7;
}else if(uType<2.5){
  float terrain=fbm(p*6.),grit=noise3(p*95.);
  float cracks=abs(terrain-.49);float lava=(1.-smoothstep(.009,.033,cracks))*(.35+noise3(p*21.)*.65);
  color=mix(vec3(.027,.025,.032),vec3(.14,.07,.045),terrain)*(.65+grit*.55);
  color+=vec3(2.9,.48,.025)*lava;emission=lava;
}else if(uType>3.5 && uType<4.5){
  float terrain=fbm(p*5.), ice=fbm(p*26.);
  float cracks=1.-smoothstep(.01,.038,abs(terrain-.49));
  color=mix(vec3(.18,.35,.43),vec3(.75,.85,.87),ice)*(.6+terrain*.6);
  color=mix(color,vec3(.06,.19,.24),cracks*.8);
}else if(uType>4.5){
  float terrain=fbm(p*4.), dunes=sin(p.y*100.+fbm(p*9.)*20.);
  color=mix(vec3(.22,.095,.05),vec3(.65,.39,.18),terrain)*(.9+dunes*.07);
  color=mix(color,vec3(.78,.73,.62),smoothstep(.83,.97,abs(p.y)+terrain*.08));
}else{
  float terrain=fbm(p*7.);float crater=pow(noise3(p*25.),3.);
  color=mix(vec3(.18,.19,.22),vec3(.55,.54,.52),terrain)*(.8+crater*.35);
}
float lighting=.018+max(sun,0.)*.98;
color=color*lighting+color*emission*.9;
vec3 air=uType<.5?vec3(.65,.44,.2):uType<1.5?vec3(.08,.43,.85):vec3(.8,.12,.025);
if(uType<2.5)color+=air*rim*(.06+day*.34);
gl_FragColor=vec4(color,1.);
}
`;
export const atmosphereFragment = /* glsl */`
uniform vec3 uColor;varying vec3 vP;varying vec3 vN;varying vec3 vWorld;
void main(){vec3 n=normalize(vN);float facing=abs(dot(n,normalize(cameraPosition-vWorld)));float rim=pow(1.-facing,3.)*smoothstep(0.,.23,facing);float sun=max(.08,dot(n,normalize(vec3(-.8,.45,.7))));gl_FragColor=vec4(uColor*1.3,rim*sun*.44);}
`;
export const ringVertex = /* glsl */`
varying vec3 vP;varying vec3 vWorld;
void main(){vP=position;vec4 p=modelMatrix*vec4(position,1.);vWorld=p.xyz;gl_Position=projectionMatrix*viewMatrix*p;}
`;
export const ringFragment = /* glsl */`
uniform float uInner;uniform float uOuter;uniform float uRadius;uniform vec3 uCenter;uniform float uTime;uniform float uBlack;
varying vec3 vP;varying vec3 vWorld;
${noise}
void main(){float r=length(vP.xy),t=(r-uInner)/(uOuter-uInner);if(t<0.||t>1.)discard;
float bands=.5+.5*sin(r*8.+sin(r*1.9)*2.);float fine=.5+.5*sin(r*39.);float structure=noise3(vec3(r*3.,0.,0.));
float gap=1.-smoothstep(.011,.016,abs(t-.61));
float alpha=(.28+.52*structure)*(.6+.4*bands)*(1.-gap*.93)*smoothstep(0.,.04,t)*(1.-smoothstep(.96,1.,t));
vec3 color=mix(vec3(.32,.29,.26),vec3(.73,.65,.51),structure)*(.82+.18*fine);
vec3 L=normalize(vec3(-.8,.45,.7)),delta=vWorld-uCenter;float along=dot(delta,L);float shadow=length(delta-L*along);float lit=along<0.?smoothstep(uRadius*.92,uRadius*1.05,shadow):1.;color*=mix(.11,1.,lit);
if(uBlack>.5){float a=atan(vP.y,vP.x);float swirls=noise3(vec3(r*.9,sin(a*8.+r*.2-uTime*.15)*2.,uTime*.02));float heat=pow(1.-t,1.4);color=mix(vec3(1.,.12,.012),vec3(3.4,2.3,1.35),heat)*(.5+swirls*.8);alpha*=.9;}
gl_FragColor=vec4(color,alpha);
}
`;
export const starVertex = /* glsl */`
attribute vec3 aColor;attribute float aSize;uniform float uRatio;uniform float uScale;uniform float uAttenuate;
varying vec3 vColor;
void main(){vColor=aColor;vec4 mv=modelViewMatrix*vec4(position,1.);gl_Position=projectionMatrix*mv;float size=aSize*uRatio*uScale;if(uAttenuate>.5){size*=500./max(20.,-mv.z);vColor*=min(1.,size);}gl_PointSize=clamp(size,.7,45.);}
`;
export const starFragment = /* glsl */`
varying vec3 vColor;void main(){vec2 p=gl_PointCoord-.5;float d=length(p);if(d>.5)discard;float core=exp(-d*d*90.);float glow=exp(-d*8.)*.22;gl_FragColor=vec4(vColor*(core+glow),1.);}
`;
export const cloudVertex = /* glsl */`
varying vec2 vUv;void main(){vUv=uv;gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.);}
`;
export const glowFragment = /* glsl */`
varying vec2 vUv;uniform vec3 uColor;
void main(){float d=length(vUv-.5)*2.;float glow=exp(-d*7.)*(1.-smoothstep(.7,1.,d));gl_FragColor=vec4(uColor,glow*.6);}
`;
